import Campaigns from './prizing'

// import middlewares
export default [{
  path: '/prizing',
  component: Campaigns,
  name: 'Campaigns',
  meta: {
    nav: {
      display: true,
      name: 'Campaigns',
      icon: 'fas fa-bullhorn'
    }
  }
}]
